import * as React from 'react';
import ProfileMenu from 'components/profile-menu';
import { ClearList } from "../clear-list";
import { getI18n } from "services/i18n-service";
import { Grid, Responsive, Segment, Message, Icon } from "semantic-ui-react";
import { ManualInputModal } from "components/manual-input-modal";
import { ScanInputModal } from "../scan-input-modal";
import { MobileMenuToggle } from "components/mobile-menu-toggle";
import { Route, Switch, RouteComponentProps } from "react-router-dom";
import { translations } from "types/translations";

import "./styles.css";
import { UserManagementMatchParams } from "pages/user-management/component";
import { NmvsMenuItem } from "types/nmvs-menu-item";

export interface ConnectedProps {
  currentOperation: NmvsMenuItem;
  isOnline: boolean;
  language: string;
}

export type Props = ConnectedProps & RouteComponentProps;

export class CertaHeader extends React.Component<Props> {
  public render() {
    const i18n = getI18n();

    const userManagementTitle = ({
      match
    }: RouteComponentProps<UserManagementMatchParams>) => (
      <span>
        {match.params.mode === "edit"
          ? i18n.t(translations.EditUser)
          : i18n.t(translations.AddUser)}
      </span>
    );

    const headerTitle = (
      <Switch>
        <Route key="main" exact={true} path={`${process.env.PUBLIC_URL}/`}>
          <span>{i18n.t(this.props.currentOperation.text)}</span>
        </Route>
        <Route key="deviceInfo" exact={true} path={`${process.env.PUBLIC_URL}/deviceInfo`}>
          <span>{i18n.t(translations.DeviceInfo)}</span>
        </Route>
        <Route key="userProfile" exact={true} path={`${process.env.PUBLIC_URL}/user/profile`}>
          <span>{i18n.t(translations.UserProfile)}</span>
        </Route>
        <Route key="users" exact={true} path={`${process.env.PUBLIC_URL}/users`}>
          <span>{i18n.t(translations.Users)}</span>
        </Route>
        <Route key="settings" exact={true} path={`${process.env.PUBLIC_URL}/settings`}>
          <span>{i18n.t(translations.Settings)}</span>
        </Route>
        <Route
          key="userManagement"
          exact={true}
          path={`${process.env.PUBLIC_URL}/user/:mode(edit|create)`}
          component={userManagementTitle}
        />
      </Switch>
    );

    const controlButtons = (
      <Switch>
        <Route key="main-buttons" exact={true} path={`${process.env.PUBLIC_URL}/`}>
          <>
            <ScanInputModal />
            <ManualInputModal />
            <ClearList />
          </>
        </Route>
      </Switch>
    );

    const mobileControlButtons = (
      <Switch>
        <Route key="main-buttons" exact={true} path={`${process.env.PUBLIC_URL}/`}>
          <Grid columns={2}>
            <Grid.Row>
              <Grid.Column mobile={8} className="fluid">
                <ManualInputModal />
              </Grid.Column>
              <Grid.Column mobile={8} className="fluid">
                <ClearList />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column mobile={16} className="fluid">
                <ScanInputModal />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Route>
      </Switch>
    );

    const undoWarningText = this.props.isOnline === false && (
      <div className="undo-warning">
        <Message color="yellow" size="tiny">
          <Message.Content>
            <Icon className="warning" name="warning sign" />
            {i18n.t(translations.UndoOfflineWarning)}
          </Message.Content>
        </Message>
      </div>
    );

    return (
      <Segment className="segment-header">
        <Responsive
          {...Responsive.onlyMobile}
          as="span"
          className="mobile-view"
        >
          <div className="flex">
            <span className="header-title">
              <MobileMenuToggle />
              {headerTitle}
            </span>

            <span className="header-right-section">
              <ProfileMenu />
            </span>
          </div>
          {mobileControlButtons}
          {undoWarningText}
        </Responsive>
        <Responsive
          minWidth={Responsive.onlyTablet.minWidth}
          as="span"
          className="other-view"
        >
          <div className="flex">
            <span className="header-title">
              <MobileMenuToggle />
              {headerTitle}
            </span>
            <span className="header-right-section">
              {controlButtons}
              <ProfileMenu />
            </span>
          </div>
          {undoWarningText}
        </Responsive>
      </Segment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/header/component.tsx